var map = {
	"./de.json": [
		"6ce2",
		"l-de-json"
	],
	"./en.json": [
		"edd4",
		"l-en-json"
	],
	"./en_GB.json": [
		"3064",
		"l-en_GB-json"
	],
	"./es.json": [
		"a306",
		"l-es-json"
	],
	"./fr.json": [
		"f693",
		"l-fr-json"
	],
	"./it.json": [
		"0825",
		"l-it-json"
	],
	"./nl.json": [
		"a625",
		"l-nl-json"
	],
	"./pt.json": [
		"5d67",
		"l-pt-json"
	],
	"./ru.json": [
		"7704",
		"l-ru-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "39c3";
module.exports = webpackAsyncContext;